var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OilDataCap',{attrs:{"title":'Счет фактура'.toUpperCase(),"search-filter":_vm.onSearchValueChange,"service-name":"invoice","buttons":[
              {
                route: 'invoice',
                name: 'Добавить Счет фактуру'
              }
           ]}}),_c('v-divider',{staticClass:"my-2"}),(_vm.loading)?_c('oil-table',{attrs:{"hide-footer":true,"item-counts":_vm.invoices.length+1,"keys":[
                        {
                          text:'Покупатель'.toUpperCase(),
                          value:'CompanyName'
                        },
                        {
                          text:'Договор'.toUpperCase(),
                          value:'ContractNumber'
                        },
                        {
                          text:'ИНН',
                          value:'TaxNo'
                        },
                        {
                          text:'Счет фактура'.toUpperCase(),
                          value:'Number'
                        },
                        {
                          text:'СКАЧАТЬ И ПЕЧАТЬ',
                          value:'PDFID'
                        },
                        {
                          text:'',
                          value:'Id'
                        },
                        {
                          text:'',
                          value:'DeleteId'
                        }
                     ],"paginate":_vm.count,"items":_vm.invoices},on:{"paginateAction":_vm.paginate},scopedSlots:_vm._u([{key:"PDFID",fn:function(ref){
                     var value = ref.value;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                     var on = ref.on;
                     var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mr-6",attrs:{"type":"button","icon":""},on:{"click":function($event){return _vm.showMePdf('invoice/print',value)}}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(" mdi-pdf-box ")])],1)]}}],null,true)},[_c('span',[_vm._v("СКАЧАТЬ И ПЕЧАТЬ")])])]}},{key:"Id",fn:function(ref){
                     var value = ref.value;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                     var on = ref.on;
                     var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.handleRowClick(value)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" mdi-pen ")])],1)]}}],null,true)},[_c('span',[_vm._v("РЕДАКТИ́РОВАТЬ")])])]}},{key:"DeleteId",fn:function(ref){
                     var value = ref.value;
return [_c('v-row',[_c('v-col',{attrs:{"md":"6","offset-md":"3"}},[_c('oil-modal',{attrs:{"value":value,"tooltipMessage":"УДАЛИТЬ","mdiIcon":"mdi-delete","accept":_vm.deleteInvoice}})],1)],1)]}}],null,false,501971570)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }